/* ==========================================================================
   BSC Academy — sistema di movimento · v1 · 24/08/2026

   Un sistema, due attributi. Il markup dichiara l'intenzione, questo file
   la esegue. Per animare qualcosa di nuovo si aggiunge l'attributo nel
   Liquid, NON si scrive JS. → playbook §9.2

     [data-reveal]     titolo che sale da una maschera, parola per parola
     [data-scroll-in]  entrata morbida quando l'elemento arriva in viewport
     [data-conta]      sul CONTENITORE: le cifre [data-numero] dentro di lui
                       compaiono e salgono da zero UNA ALLA VOLTA — la
                       seconda entra quando la prima ha finito di contare

   ⚠️ Lo stato nascosto lo mette GSAP a runtime, MAI il CSS: se il JS muore,
      la pagina resta visibile e indicizzabile per costruzione. → §9.3
   ⚠️ Nessun ramo `prefers-reduced-motion`: le animazioni si vedono sempre,
      da tutti. Default permanente di Rami dal 17/08/2026. → §9.6
   ========================================================================== */

(function () {
  'use strict';

  var AVVIATO = false;
  var SAFETY_MS = 1500;

  /* ---- rete di sicurezza -------------------------------------------------
     Se i font non caricano, se GSAP non c'è, se un trigger non scatta mai:
     il contenuto si vede comunque. Questa funzione RIVELA, non anima. */
  function rivela(scope) {
    var nodi = (scope || document).querySelectorAll('[data-reveal], [data-scroll-in]');
    for (var i = 0; i < nodi.length; i++) {
      nodi[i].style.visibility = 'visible';
      nodi[i].style.opacity = '1';
      nodi[i].style.transform = 'none';
    }
  }

  /* ---- [data-reveal] — titoli -------------------------------------------- */
  function reveal(g, el) {
    if (el.dataset.bscInit) { return; }
    el.dataset.bscInit = '1';

    // Senza SplitText si degrada a un fade semplice: il titolo si vede.
    if (typeof window.SplitText === 'undefined') {
      g.set(el, { autoAlpha: 0, y: 14 });
      g.to(el, { autoAlpha: 1, y: 0, duration: .7, ease: 'power3.out' });
      return;
    }

    // Split a PAROLA, mai a lettera: gli screen reader compiterebbero.
    // Il text content resta la frase intera. → playbook §9.5
    var split = new SplitText(el, {
      type: 'words',
      wordsClass: 'bsc-parola',
      aria: 'auto',
      autoSplit: true
    });

    // maschera: le parole partono sotto il loro contenitore
    for (var i = 0; i < split.words.length; i++) {
      split.words[i].style.display = 'inline-block';
      split.words[i].style.willChange = 'transform';
    }
    el.style.overflow = 'clip';
    el.style.paddingBottom = '.16em';   // spazio per i discendenti: g, p, q
    el.style.marginBottom = '-.16em';

    g.set(split.words, { yPercent: 115 });
    g.to(split.words, {
      yPercent: 0,
      duration: 1.05,
      ease: 'expo.out',
      stagger: 0.06,
      onComplete: function () { el.style.overflow = ''; }
    });
  }

  /* ---- [data-scroll-in] — tutto il resto --------------------------------- */
  function scrollIn(g, el) {
    if (el.dataset.bscInit) { return; }
    el.dataset.bscInit = '1';

    if (!window.ScrollTrigger) {   // niente ScrollTrigger: mostra subito
      g.set(el, { autoAlpha: 1, y: 0 });
      return;
    }

    g.set(el, { autoAlpha: 0, y: 24 });
    g.to(el, {
      autoAlpha: 1,
      y: 0,
      duration: 0.9,
      ease: 'power3.out',
      scrollTrigger: { trigger: el, start: 'top 85%', once: true }
    });
  }

  /* ---- [data-conta] — cifre che salgono -----------------------------------
     L'attributo sta sul contenitore, non sulla singola cifra: e il gruppo che
     decide l'ordine. Le cifre partono quando il gruppo entra in schermo e
     salgono UNA ALLA VOLTA — tre conti in parallelo sono rumore, in fila
     sono un racconto. (Rami, 25/08)

     ⚠️ Senza ScrollTrigger non si tocca niente: in pagina restano i numeri
        veri, scritti nel Liquid. Il conto e un di piu, mai il contenuto. */
  function conta(g, gruppo) {
    if (gruppo.dataset.bscInit) { return; }
    gruppo.dataset.bscInit = '1';

    if (!window.ScrollTrigger) { return; }

    var nodi = gruppo.querySelectorAll('[data-numero]');
    var conti = [];

    for (var i = 0; i < nodi.length; i++) {
      var el = nodi[i];
      var testo = (el.textContent || '').trim();
      /* prefisso non numerico + cifre + suffisso: "+12.000", "12", "3 ore" */
      var pezzi = /^(\D*)(\d[\d.\s ]*\d|\d)(\D*)$/.exec(testo);
      if (!pezzi) { continue; }

      var valore = parseInt(pezzi[2].replace(/[.\s ]/g, ''), 10);
      if (!isFinite(valore) || valore <= 0) { continue; }

      /* il separatore delle migliaia si CONSERVA com'era scritto: se il
         proprietario scrive "2000" resta 2000, se scrive "2.000" resta
         puntato. Non e il codice a decidere come si scrivono i numeri. */
      conti.push({
        el: el,
        pre: pezzi[1],
        post: pezzi[3],
        val: valore,
        punti: pezzi[2].indexOf('.') !== -1,
        finale: testo,
        box: (el.parentNode && el.parentNode !== gruppo) ? el.parentNode : el
      });
    }

    if (!conti.length) { return; }

    function scrivi(c, n) {
      var cifra = Math.round(n);
      c.el.textContent = c.pre + (c.punti ? cifra.toLocaleString('it-IT') : String(cifra)) + c.post;
    }

    /* La larghezza si blocca PRIMA di azzerare, mentre in pagina c'e ancora
       il numero finale — che e il piu lungo. Senza questo la riga si
       restringe su "0" e quello che le sta accanto scivola.
       Si blocca sul contenitore, non sulla cifra: e lui che il layout misura. */
    for (var b = 0; b < conti.length; b++) {
      conti[b].box.style.minWidth = conti[b].box.getBoundingClientRect().width + 'px';
      scrivi(conti[b], 0);
      g.set(conti[b].box, { autoAlpha: 0, y: 18 });
    }

    /* ⚠️ IL PERCHE NON SI VEDEVA (Rami, 25/08).
       Questo blocco e la SECONDA sezione della home: sotto un hero da 50vh
       e gia dentro lo schermo appena la pagina apre. ScrollTrigger faceva il
       suo dovere e faceva partire il conto subito — durante il caricamento,
       mentre l'hero stava ancora entrando. Finiva prima che ci si arrivasse
       con l'occhio: non era fermo, era gia finito.
       Quindi: se il gruppo e gia in schermo all'apertura, il conto ASPETTA
       che l'hero abbia finito di entrare e parte dopo. Se invece sta piu in
       basso, parte quando ci arrivi, e l'attesa non serve. */
    var giaInSchermo = gruppo.getBoundingClientRect().top < window.innerHeight * 0.82;

    var tl = g.timeline({
      scrollTrigger: { trigger: gruppo, start: 'top 82%', once: true },
      onComplete: function () {
        for (var k = 0; k < conti.length; k++) {
          conti[k].el.textContent = conti[k].finale;
          conti[k].box.style.minWidth = '';
        }
        /* chi aspetta che le cifre siano ferme lo scopre da qui: il nastro
           dei numeri non puo clonare la fila prima di adesso. → bsc-prova.js */
        try {
          gruppo.dispatchEvent(new CustomEvent('bsc:conta:fine', { bubbles: true }));
        } catch (e) {}
      }
    });

    /* la pausa e un tween a vuoto e non un `delay`: dentro una timeline
       comandata da ScrollTrigger il delay si comporta in modo ambiguo */
    if (giaInSchermo) { tl.to({}, { duration: 1.15 }); }

    for (var t = 0; t < conti.length; t++) {
      (function (c) {
        var proxy = { n: 0 };

        /* entra… */
        tl.to(c.box, { autoAlpha: 1, y: 0, duration: 0.45, ease: 'power3.out' });

        /* …e conta mentre entra ('<' = stesso istante di partenza).
           power2.out: il conto rallenta arrivando, il numero non si ferma,
           ATTERRA. Il blocco dopo parte solo a questo finito: e la fila
           che rende leggibile il racconto. (Rami, 25/08) */
        tl.to(proxy, {
          n: c.val,
          duration: 1.05,
          ease: 'power2.out',
          onUpdate: function () { scrivi(c, proxy.n); }
        }, '<');
      })(conti[t]);
    }
  }

  /* ---- montaggio ---------------------------------------------------------- */
  function monta(scope) {
    var g = window.gsap;
    if (!g) { rivela(scope); return; }

    var root = scope || document;
    var titoli = root.querySelectorAll('[data-reveal]');
    var blocchi = root.querySelectorAll('[data-scroll-in]');
    var gruppi = root.querySelectorAll('[data-conta]');

    for (var i = 0; i < titoli.length; i++) { reveal(g, titoli[i]); }
    for (var j = 0; j < blocchi.length; j++) { scrollIn(g, blocchi[j]); }
    for (var c = 0; c < gruppi.length; c++) { conta(g, gruppi[c]); }

    if (window.ScrollTrigger) { ScrollTrigger.refresh(); }
  }

  /* ---- smontaggio: obbligatorio nel theme editor --------------------------
     Il pannello aggiunge e rimuove sezioni senza ricaricare la pagina.
     Senza questo, le timeline restano appese a nodi che non esistono più:
     è il leak che non si vede finché il pannello non rallenta. → §0.1.3 */
  function smonta(scope) {
    if (!scope) { return; }
    var nodi = scope.querySelectorAll('[data-reveal], [data-scroll-in], [data-conta]');
    for (var i = 0; i < nodi.length; i++) {
      var el = nodi[i];
      if (window.gsap) {
        var tws = gsap.getTweensOf(el);
        for (var t = 0; t < tws.length; t++) {
          if (tws[t].scrollTrigger) { tws[t].scrollTrigger.kill(); }
          tws[t].kill();
        }
      }
      delete el.dataset.bscInit;
    }
  }

  /* ---- avvio --------------------------------------------------------------
     Parte a font caricati (le posizioni di SplitText dipendono dal font),
     con timer di sicurezza: se document.fonts non risolve, si va lo stesso. */
  function avvia() {
    if (AVVIATO) { return; }
    AVVIATO = true;

    (window.WS_GSAP ? WS_GSAP.ready : function (f) { window.addEventListener('load', f); })(function () {
      monta(document);
    });

    // rete di sicurezza: qualunque cosa accada, dopo 1,5s il contenuto si vede
    setTimeout(function () {
      var fermi = document.querySelectorAll('[data-reveal]:not([data-bsc-init]), [data-scroll-in]:not([data-bsc-init])');
      if (fermi.length && !window.gsap) { rivela(document); }
    }, SAFETY_MS);
  }

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(avvia);
    setTimeout(avvia, SAFETY_MS);
  } else {
    avvia();
  }

  /* ---- eventi del theme editor -------------------------------------------- */
  document.addEventListener('shopify:section:load', function (e) { monta(e.target); });
  document.addEventListener('shopify:section:unload', function (e) { smonta(e.target); });
})();
